import {Injectable} from '@angular/core';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {LoginService} from '../shared/navigation/login.service';
import {UserService} from './user.service';

@Injectable({
    providedIn: 'root'
})
export class BonusService {
    lastGetBonusDetails = 0;

    constructor(private lotteryService: LotteriesService,
                private loginService: LoginService,
                private userService: UserService) {
    }

    cancelBonus(userIncentiveId) {
        return new Promise(resolve => {
            const sendData = {};
            sendData['sessionId'] = this.userService.userData.sessionId;
            sendData['userIncentiveId'] = userIncentiveId;
            let memberId;
            if (this.userService &&
                this.userService.userData &&
                this.userService.userData.memberId) {
                memberId = this.userService.userData.memberId;
            } else {
                memberId = 0;
            }
            this.lotteryService.postData(`${globals.appDomain}/incentives/cancelBonus/${memberId}/cancelBonus.json`,
                this.loginService.getFormUrlEncoded(sendData))
                .subscribe(
                    result => {
                        resolve(result);
                    }
                );
        });
    }

    getBonusDetails() {
        return new Promise(resolve => {
            const date = new Date();
            const time = date.getTime();
            const sendData = {};
            sendData['sessionId'] = this.userService.userData.sessionId;
            let memberId;
            if (this.userService &&
                this.userService.userData &&
                this.userService.userData.memberId) {
                memberId = this.userService.userData.memberId;
            } else {
                memberId = 0;
            }
            if ((time - this.lastGetBonusDetails) > 1000) {
                this.lastGetBonusDetails = time;
                this.lotteryService.postData(
                    `${globals.appDomain}/payments/getPaymentMethods/${memberId}/getBonusIncentive.json`,
                    this.loginService.getFormUrlEncoded(sendData))
                    .subscribe(
                        result => {
                            resolve(result);
                        }
                    );
            }
        });
    }

    getIncentivesHistory() {
        return new Promise(resolve => {
            const sendData = {};
            sendData['sessionId'] = this.userService.userData.sessionId;
            sendData['moneyOnly'] = 1;
            this.lotteryService.postData(`${globals.appDomain}/history/incentives/${this.userService.userData.memberId}/incentives.json`,
                this.lotteryService.getFormUrlEncoded(sendData)).subscribe(result => {
                resolve(result);
            });
        });
    }
}

